import styles from './Paper.module.css';
import { Paper as MantinePaper, PaperProps as MantinePaperProps, ElementProps } from '@mantine/core';
import { cva, VariantProps } from 'class-variance-authority';

const variants = cva(styles.base, {
    variants: {
        appearance: {
            solid: styles.solid,
            outline: styles.outline,
        },
    },
    defaultVariants: {
        appearance: 'outline',
    },
});

export type PaperProps = VariantProps<typeof variants> &
    MantinePaperProps &
    ElementProps<'div', keyof MantinePaperProps>;

export const Paper = ({ children, appearance, withBorder = true, ...props }: PaperProps) => {
    return (
        <MantinePaper className={variants({ appearance })} withBorder={withBorder} {...props}>
            {children}
        </MantinePaper>
    );
};
